import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import PlantGrid, { PlantThumb } from "./PlantGrid";

export default function PlantSwitch({ plants, value, onChange, testid = "plant-switch" }) {
  const [open, setOpen] = useState(false);
  const p = plants.find((x) => x.id === value);
  return (
    <div data-testid={testid} className="mb-6">
      <div className="flex items-center gap-3">
        <PlantThumb plant={p} className="h-9 w-9 rounded-xl shrink-0" />
        <div className="min-w-0 flex-1 leading-tight">
          <p className="text-sm font-medium truncate" data-testid={`${testid}-name`}>{p?.nickname || "Loading…"}</p>
          <p className="text-[11px] font-mono text-muted-foreground truncate">{p?.plant_code}</p>
        </div>
        <button type="button" onClick={() => setOpen((o) => !o)} data-testid={`${testid}-change`}
          className="text-xs font-medium text-muted-foreground hover:text-foreground px-2 py-1 rounded-full hover:bg-muted transition-colors">
          {open ? "Done" : "Change"}
        </button>
      </div>
      <AnimatePresence initial={false}>
        {open && (
          <motion.div initial={{ height: 0, opacity: 0 }} animate={{ height: "auto", opacity: 1 }} exit={{ height: 0, opacity: 0 }} transition={{ duration: 0.22, ease: "easeOut" }} className="overflow-hidden">
            <div className="pt-4 pb-1"><PlantGrid plants={plants} value={value} prefix={`${testid}-plant`} onPick={(id) => { onChange(id); setOpen(false); }} /></div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
